import styled, { css } from 'styled-components';
import { T as Text } from '../Text/Text-Ce2yOjWM.js';
import { S as STATUS } from './constants-d5DDIlHP.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StepContainer = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-storm-ui-40025937__sc-tnk4bf-0"
})(["list-style-type:none;display:inline-grid;flex:1;", ""], ({
  $isVertical,
  $inlineLabel
}) => {
  if ($isVertical) {
    if ($inlineLabel) {
      return css(["justify-items:center;grid-template-columns:1fr;grid-template-rows:24px max-content 1fr;grid-template-areas:\"circle\" \"content\" \"postline\";"]);
    }
    if (!$inlineLabel) {
      return css(["grid-template-columns:24px 1fr;grid-template-rows:24px 1fr;grid-template-areas:\"circle content\" \"postline content\";"]);
    }
  }
  if (!$isVertical) {
    if ($inlineLabel) {
      return css(["grid-auto-columns:18px max-content auto;grid-template-areas:\"circle content postline\";"]);
    }
    if (!$inlineLabel) {
      return css(["grid-auto-columns:1fr 24px 1fr;grid-auto-rows:max-content;grid-template-areas:\"preline circle postline\" \"content content content\";"]);
    }
  }
  return '';
});
const Circle = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-tnk4bf-1"
})(["grid-area:circle;border-radius:50%;height:", ";width:", ";justify-self:center;", " display:flex;justify-content:center;align-content:center;font:", ";color:", ";background-color:", ";"], ({
  theme
}) => theme.steps.iconDiameter, ({
  theme
}) => theme.steps.iconDiameter, ({
  $isVertical
}) => $isVertical && css(["align-self:center;"]), ({
  theme
}) => theme.font.text.xsmall.default, ({
  theme
}) => theme.icon.color.inverted, ({
  theme,
  $status
}) => {
  switch ($status) {
    case STATUS.FUTURE:
      return theme.steps.iconColor.future;
    case STATUS.ACTIVE:
      return theme.steps.iconColor.active;
    case STATUS.COMPLETED:
      return theme.steps.iconColor.active;
    case STATUS.DISABLED:
      return theme.steps.iconColor.unavailable;
    default:
      return theme.steps.iconColor.future;
  }
});
const PreLine = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-tnk4bf-2"
})(["grid-area:preline;background-color:", ";margin-block-start:", ";margin-inline-end:", ";height:", ";min-width:10px;"], ({
  theme
}) => theme.border.color.subtle.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.border.width.default);
const PostLine = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-tnk4bf-3"
})(["grid-area:postline;background-color:", ";height:", ";min-width:10px;margin-block-start:", ";margin-inline-start:", ";", " ", ""], ({
  theme
}) => theme.border.color.subtle.default, ({
  theme
}) => theme.border.width.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  $inlineLabel
}) => $inlineLabel && css(["margin-inline-end:", ";"], ({
  theme
}) => theme.spacing.xsmall.default), ({
  $isVertical
}) => $isVertical && css(["height:unset;min-height:10px;width:", ";min-width:unset;margin-block-end:", ";"], ({
  theme
}) => theme.border.width.default, ({
  theme
}) => theme.spacing.xsmall.default));
const Content = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-tnk4bf-4"
})(["grid-area:content;display:flex;flex-direction:column;margin-inline-start:", ";color:", ";", " ", ""], ({
  theme
}) => theme.selectableWidget.controlLabelGap.default, ({
  $status,
  theme
}) => $status === STATUS.DISABLED ? theme.text.color.unavailable : theme.text.color.default, ({
  $isVertical,
  $inlineLabel
}) => !$isVertical && !$inlineLabel && css(["margin:auto;"]), ({
  $isVertical,
  $inlineLabel
}) => $isVertical && $inlineLabel && css(["margin-inline-start:", ";", ""], ({
  theme
}) => theme.selectableWidget.controlLabelGap.default, isMobile(css(["margin-inline-start:", ";"], ({
  theme
}) => theme.selectableWidget.controlLabelGap.mobile))));
const LabelWrapper = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40025937__sc-tnk4bf-5"
})(["", ";color:", ";"], ({
  $status,
  theme
}) => $status === STATUS.ACTIVE && css(["font-weight:", ""], theme.font.weight.bold), ({
  $status,
  theme
}) => $status === STATUS.DISABLED ? theme.text.color.unavailable : theme.text.color.default);

export { Circle as C, LabelWrapper as L, PreLine as P, StepContainer as S, PostLine as a, Content as b };
//# sourceMappingURL=Step.styles-WJMozk4V.js.map
